import { useMemo } from 'react';
import { EllipsisText, EmptyPlaceholder } from '@gv/triage-components';

import { DataCellProps } from './types';

const isFieldValidToShow = <T,>(data: T, field: keyof T) =>
  !!data[field] &&
  (typeof data[field] === 'string' || typeof data[field] === 'number');

export const DataCell = <T,>({ data, fields }: DataCellProps<T>) => {
  const fieldToShow = useMemo(
    () => data && fields.find((field) => isFieldValidToShow(data, field)),
    [data, fields]
  );

  return !!fieldToShow && data ? (
    <EllipsisText>{data[fieldToShow] as string | number}</EllipsisText>
  ) : (
    <>{EmptyPlaceholder}</>
  );
};
